const myTransactions = {
  selectDateRage:'Виберіть діапазон дат',
  selectTransactionType:'Виберіть тип транзакції',
  selectApplication:'Виберіть програму',
  export:'Експорт',
};

export default myTransactions;
